import { dateObjectAsDailyPuzzleLink } from "@/common/functions";
import { PAGES } from "@/common/consts";
import { DAILY_COLORS } from "@/common/daily_colors";

export default {
	name: "DailyPuzzleCard",
	props: {
		squared: {
			type: Boolean,
			required: false,
			default: false,
		},
		hasSecondaryLink: {
			type: Boolean,
			required: false,
		},
		showHint: {
			type: Boolean,
			default: false,
		},
		currentDate: {
			type: Object,
			required: true,
		},
	},
	computed: {
		dailyCardTopText() {
			if (this.currentDate.day >= 1 && this.currentDate.day <= 9) {
				return `0${this.currentDate.day}`;
			}
			return this.currentDate.day;
		},
		dailyCardBottomtext() {
			const monthText = this.currentDate.month.slice(0, 3).toUpperCase();
			if (this.squared) {
				return `${monthText} ${this.currentDate.year}`;
			}

			return monthText;
		},
		dailyCardUrl() {
			return dateObjectAsDailyPuzzleLink(this.currentDate);
		},
		dailyCardColor() {
			const month = new Date(Object.values(this.currentDate)).getMonth();
			return DAILY_COLORS[month][this.currentDate.day - 1];
		},
		primaryLinkData() {
			const titleKey = this.showHint
				? "WordscapesDailyInternalLinkTitleAttribute"
				: "WordscapesDailyModuleDailyDetailTitleAttribute";
			return {
				text: this.$t("WordscapesDailyModuleDailyDetailText"),
				url: this.dailyCardUrl,
				title: this.$t(titleKey, {
					Month: this.currentDate.month,
					DayOrdinalFormat: this.dailyCardDay,
					Year: this.currentDate.year,
				}),
			};
		},
		secondaryLinkData() {
			return {
				text: this.$t("WordscapesDailyModuleDailyIndexText"),
				url: this.$t("WordscapesDailyModuleDailyIndexUrl"),
				title: this.$t("WordscapesDailyModuleDailyIndexTitleAttribute"),
			};
		},
		isDailyPuzzleIndexPage() {
			return this.$route.name === PAGES.DAILY_PUZZLE_INDEX;
		},
	},
};
